module.exports = __webpack_public_path__ + "img/Stortingsmelding_Arne_Garborg.afe1dbed.jpg";